import {Card, CardContent, CardHeader} from "@/components/ui/card.tsx";
import {Button} from "@/components/ui/button.tsx";
import {ChevronDown} from "lucide-react";
import {Extension} from "@/types/extenions.ts";
import {Fragment, ReactNode, useContext, useMemo, useState} from "react";
import collect, {Collection} from "collect.js";
import {ExtensionType} from "@/types/Systems.ts";
import {cn} from "@/lib/utils.ts";
import {SubExtensions} from "@/pages/extensions/components/SubExtensions.tsx";
import {ExtensionContext, useExtensionEdit} from "@/pages/extensions/components/ProviderExtensionEdit.tsx";
import {useGetExtensionsTypes} from "@/hooks/useExtensionsTypes.ts";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbSeparator
} from "@/components/ui/breadcrumb";
import {
    DropdownMenu,
    DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem,
    DropdownMenuTrigger
} from "@/components/ui/dropdown-menu.tsx";
import {
    ArrowUpTrayIcon,
    EllipsisVerticalIcon,
    FolderOpenIcon
} from "@heroicons/react/24/outline";
import {Tooltip, TooltipContent, TooltipTrigger} from "@/components/ui/tooltip.tsx";
import {allowSubExtensions, allowAddAudioFile} from "@/pages/extensions/helpers.ts";
import {useForm} from "react-hook-form";
import {Form, FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form.tsx";
import {z} from "zod";
import {zodResolver} from "@hookform/resolvers/zod";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue
} from "@/components/ui/select.tsx";
import {Input} from "@/components/ui/input.tsx";
import {useCreateExtensionMutation} from "@/store/extensions.ts";
import {toast} from "sonner";
import {Spinner} from "@/components/ui/spinner.tsx";
import {GetGlobalActions} from "@/pages/extensions/components/gloabl-actions.tsx";
import {ActionsExtension} from "@/pages/extensions/components/ActionsExtension.tsx";
export interface ExtensionCardProps  extends Extension {
    isMain?: true;
    isDeepSub?: true;
}

export function ExtensionCard(props: ExtensionCardProps) {

    const [openSubExtension, setOpenSubExtension] = useState(false);
    const [openAddSubExtension, setOpenAddSubExtension] = useState(false);

    const types = useGetExtensionsTypes();

    const type: ExtensionType = useMemo(() => collect(types).firstWhere('value', props.cls_type), [types, props.cls_type]);

    const isMain = useMemo(() => props.isMain || props.conf_id.indexOf('.') === -1, [props.conf_id, props.isMain]);

    // if(!types || !type) {
    //     return null;
    // }

    const actions = useMemo(() => {
        const actionsList = [];

        if(allowAddAudioFile.includes(props.cls_type)) {
            actionsList.push(
                <DropdownMenuItem asChild key="move_to_recordings">
                    <a href={`/learning/streamfilesclass/?_sclass=${props.id}`}>
                        <FolderOpenIcon/>מעבר להקלטות שלוחה
                    </a>
                </DropdownMenuItem>,
                <DropdownMenuItem key="add_recording" onClick={() => {
                    //open window as popup
                    //`/learning/streamfilesclass/add/?_popup=1&sclass=${props.id}&type=MSG`
                    window.open(`/learning/streamfilesclass/add/?_popup=1&sclass=${props.id}&type=MSG`, 'popup', 'width=800,height=600');
                }}>
                    <ArrowUpTrayIcon/>
                    העלאת קובץ
                </DropdownMenuItem>
            )
        }

        return actionsList;
    }, [props.cls_type]);

    return (
        <Card className={cn("relative", props.isDeepSub && "rounded-none shadow-none border-b last:border-b-0 border-gray-100 ms-6")}>
            <CardHeader className={cn("flex-row items-center justify-between px-3 ", props.isDeepSub ? "py-2" : 'py-3', openSubExtension && 'border-b border-gray-100')}>
                <div className="flex gap-4 items-center">
                    <div>
                        <KeyExtensionIcon path={props.path}/>
                    </div>
                    <div>
                        <h3 className="font-medium text-sm text-gray-900">{props.name ?? 'אין שם'}</h3>
                        <p className="text-xs text-gray-400">{type?.name ?? props.cls_type}  {!!props.count_sub_sclass && `(${props.count_sub_sclass})`}</p>
                    </div>
                </div>

                <div className="flex gap-3 items-center">
                    <div className="flex gap-2.5 items-center">
                        {props.path && props.path?.indexOf('.') !== -1 &&
                            <div>
                                <Breadcrumb dir="rtl">
                                    <BreadcrumbList className="!gap-0.5">
                                        <BreadcrumbItem className="text-xs pb-[0.15rem]">
                                            נתיב:
                                        </BreadcrumbItem>
                                        {props.path?.split('.').map((ext, index) => (
                                            <Fragment key={index}>
                                                <BreadcrumbItem className="text-xs pb-[0.15rem]">
                                                    <BreadcrumbLink href={`/learning/sclass/path/${props.path.split('.').slice(0, index +1).join('.')}/`}>
                                                        {ext}
                                                    </BreadcrumbLink>
                                                </BreadcrumbItem>
                                                {index !== props.path.split('.').length - 1 && (
                                                    <BreadcrumbSeparator className="[&>svg]:size-2.5"/>
                                                )}
                                            </Fragment>
                                        ))}
                                    </BreadcrumbList>
                                </Breadcrumb>
                            </div>
                        }
                        {/*<Button className="rounded-full" variant="ghost" size="icon-sm">*/}
                        {/*    <SpeakerWaveIcon className="!size-5 text-gray-400"/>*/}
                        {/*</Button>*/}
                        {/*{!props.isMain && (*/}
                        {/*    <>*/}
                        {/*        <Button className="rounded-full" variant="ghost" size="icon-sm">*/}
                        {/*            <TrashIcon className="!size-5 text-gray-400"/>*/}
                        {/*        </Button>*/}
                        {/*        <Button className="rounded-full" variant="ghost" size="icon-sm">*/}
                        {/*            <DocumentDuplicateIcon className="!size-5 text-gray-400"/>*/}
                        {/*        </Button>*/}
                        {/*    </>*/}
                        {/*)}*/}
                        {allowSubExtensions.includes(props.cls_type) && (
                            <Button
                                className="cursor-pointer rounded-full max-h-6 px-2.5"
                                size="sm"
                                variant="flat"
                                onClick={() => setOpenAddSubExtension(v => !v)}
                            >
                                הוספת תת שלוחה
                            </Button>
                        )}


                        <ActionsExtension ext={props}/>

                        <GetGlobalActions ext={props} isMain={isMain}/>
                    </div>
                    <div>
                        {!isMain && allowSubExtensions.includes(props.cls_type) ? (
                            <Button className="rounded-full" variant="ghost" size="icon-xs" onClick={() => setOpenSubExtension(v => !v)}>
                                <ChevronDown className={cn("!size-4 stroke-3 text-gray-400 transition", openSubExtension && 'rotate-180')}/>
                            </Button>
                        ) : <span className="block size-6"/>}
                    </div>
                </div>
            </CardHeader>
            {openAddSubExtension && (
                <CardContent className="!p-0">
                    <AddExtension
                        mainPath={props.path}
                        cls_type={props.cls_type}
                        main={props.id}
                        onSuccess={() => {
                            setOpenAddSubExtension(false);
                        }}
                    />
                </CardContent>
            )}
            {openSubExtension && (
                <CardContent className="!p-0">
                    <SubExtensions
                        main={props.id}
                        hasSubExtensions={!!props.count_sub_sclass}
                    />
                </CardContent>
            )}
        </Card>
    )
}

const addExtensionFormSchema = z.object({
    name: z.string().min(1, {message: 'שדה חובה'}),
    cls_type: z.string().min(1, {message: 'שדה חובה'}),
    //path is string but is numeric
    path: z.string().regex(/^[0-9]+$/, {message: 'שדה חובה'}),
    settings: z.object({}),
});

type AddExtensionForm = z.infer<typeof addExtensionFormSchema>;

function AddExtension({mainPath, onSuccess, main}: {
    mainPath: string,
    cls_type: string,
    onSuccess: () => void
    main: number
}) {

    const {edit} = useContext(ExtensionContext) ?? {};

    const form = useForm<AddExtensionForm>({
        defaultValues: {
            name: '',
            cls_type: '',
            path: '',
            settings: {},
        },
        resolver: zodResolver(addExtensionFormSchema),
    });

    const [createExtension] = useCreateExtensionMutation();

    const extensionsTypes = useGetExtensionsTypes(t => t.priority < 100);

    async function handleSubmit(data: AddExtensionForm) {
        await createExtension({
            ...data,
            main,
            path: mainPath ? `${mainPath}.${data.path}` : data.path,
        }).unwrap().then( res => {
            onSuccess && onSuccess();
            toast.success(`השלוחה ${res.name} נוספה בהצלחה`, {
                dismissible: false,
                action: edit ? {
                    label: 'ערוך שלוחה',
                    onClick: () => {
                        edit(res);
                    }
                }: undefined,
            });
        }).catch(res => {
            collect<string[]>(res.data.errors)
                .each((error, key) =>
                    form.setError(key as keyof AddExtensionForm, {
                        type: 'manual',
                        message: error[0],
                    })
                );
        });
    }

    return (
        <div className="p-4">
            <Form {...form}>
                <form className="flex gap-6 items-start" onSubmit={form.handleSubmit(handleSubmit)}>
                    <FormField
                        control={form.control}
                        name="name"
                        render={({ field }) => (
                            <FormItem className="space-y-2 w-full">
                                <FormLabel className="text-xs leading-[10.4px]">שם שלוחה</FormLabel>
                                <FormControl>
                                    <Input autoFocus className="h-9" placeholder="שם השלוחה" {...field} />
                                </FormControl>
                                <FormMessage/>
                            </FormItem>
                        )}
                    />

                    <FormField
                        control={form.control}
                        name="cls_type"
                        render={({ field }) => (
                            <FormItem className="space-y-2 w-full">
                                <FormLabel className="text-xs leading-[10.4px]">סוג שלוחה</FormLabel>
                                <Select
                                    dir="rtl"
                                    onValueChange={field.onChange}
                                    defaultValue={field.value}
                                >
                                    <FormControl>
                                        <SelectTrigger className="w-full">
                                            <SelectValue placeholder="בחר סוג שלוחה"/>
                                        </SelectTrigger>
                                    </FormControl>
                                    <SelectContent className="max-h-96">
                                        {collect(extensionsTypes)
                                            .groupBy<Collection<ExtensionType>, string>('group')
                                            .map((types, group) =>
                                                <SelectGroup key={group}>
                                                    <SelectLabel>{group}</SelectLabel>
                                                    {types.map(type =>
                                                        <SelectItem key={type.id} value={type.value}>
                                                            {type.name}
                                                        </SelectItem>
                                                    ).all()}
                                                </SelectGroup>
                                            ).values<ReactNode>().all()}
                                    </SelectContent>
                                </Select>
                                <FormMessage/>
                            </FormItem>
                        )}
                    />

                    <FormField
                        control={form.control}
                        name="path"
                        render={({ field }) => (
                            <FormItem className="space-y-2 w-full">
                                <FormLabel className="text-xs leading-[10.4px]">נתיב שלוחה</FormLabel>
                                <FormControl>
                                    <Input className="h-9" {...field} />
                                </FormControl>
                                <FormMessage/>
                            </FormItem>
                        )}
                    />

                    <Button
                        disabled={form.formState.isSubmitting}
                        type="submit"
                        className="mt-[18px] flex-shrink-0"
                    >
                        {form.formState.isSubmitting && (
                            <Spinner className="ms-2" />
                        )}
                        <span className="text-xs">הוספה</span>
                    </Button>
                </form>
            </Form>
        </div>
    )
}

function KeyExtensionIcon({path}: {path?: string}) {

    const pathLabel = useMemo(() => {

        if(!path) {
            return "0";
        }

        return path.split('.').pop();

    }, [path]);

    const level = useMemo(() => path ? path.split('.').length || null : null, [path]);

    const textSize = useMemo(() => cn(
        (pathLabel ?? '').length > 3 && 'text-[0.7rem]'
    ), [pathLabel]);

    return (
        <div className={cn("flex rounded-full items-center justify-center h-10 min-w-10 px-2", {
            // 'bg-blue-50': level === null,
            'bg-gray-100': level === null,
            'bg-light-blue-50': level === 1,
            'bg-green-50': level === 2,
            'bg-orange-50': level === 3,
            'bg-sky-50': level === 4,
            'bg-yellow-50': level === 5,
            'bg-slate-100': (level ?? 0) > 5,
        })}>
            <div className={cn("flex px-0.5 min-w-[1.125rem] h-4.5 leading-[18px] pb-[0.1rem] items-center justify-center text-white rounded-md", textSize, {
                // 'bg-light-blue-500': level === null,
                'bg-gray-700': level === null,
                'bg-blue-900': level === 1,
                'bg-green-500': level === 2,
                'bg-orange-500': level === 3,
                'bg-sky-500': level === 4,
                'bg-yellow-500': level === 5,
                'bg-slate-700': (level ?? 0) > 5,
            })}>{pathLabel}</div>
        </div>
    )
}